import { render, staticRenderFns } from "./ProductsTreeView.vue?vue&type=template&id=79ad351f&scoped=true"
import script from "./ProductsTreeView.vue?vue&type=script&lang=js"
export * from "./ProductsTreeView.vue?vue&type=script&lang=js"
import style0 from "./ProductsTreeView.vue?vue&type=style&index=0&id=79ad351f&prod&scoped=true&lang=scss"
import style1 from "./ProductsTreeView.vue?vue&type=style&index=1&id=79ad351f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ad351f",
  null
  
)

export default component.exports